import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function DonateCancel() {
  return (
    <div
      data-testid="donate-cancel-page"
      className="min-h-screen flex items-center justify-center bg-brand-cream px-4 py-20"
    >
      <div className="w-full max-w-xl bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-slate-200 text-center">
        <div className="w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center mx-auto">
          <Heart className="w-10 h-10 text-slate-400" />
        </div>
        <h1 className="mt-6 font-display font-black text-3xl md:text-4xl text-brand-navy">
          No worries — we&apos;re still here.
        </h1>
        <p className="mt-4 text-lg text-slate-600">
          Your checkout was cancelled and no payment was taken. Whenever the
          timing is right, we&apos;d love your support.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/#donate">
            <Button
              data-testid="cancel-retry-btn"
              className="rounded-full bg-brand-coral hover:bg-brand-coralDark text-white font-bold px-8 h-12 w-full sm:w-auto"
            >
              Try donating again
            </Button>
          </Link>
          <Link to="/">
            <Button
              data-testid="cancel-home-btn"
              variant="outline"
              className="rounded-full border-2 border-brand-navy text-brand-navy hover:bg-brand-navy hover:text-white font-bold px-8 h-12 w-full sm:w-auto"
            >
              Back home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
